/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spellcheck_Corrections_List_LabelInputs */

const en_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`List of spelling corrections`)
};

const fr_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste des corrections orthographiques`)
};

const de_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liste der Rechtschreibkorrekturen`)
};

const it_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elenco delle correzioni ortografiche`)
};

const ru_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Список орфографических исправлений`)
};

const es_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de correcciones ortográficas`)
};

const zh_cn2_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拼写错误更正列表`)
};

const ja_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペル修正リスト`)
};

const hi_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वर्तनी सुधारों की सूची`)
};

const pt_pt2_spellcheck_corrections_list_label = /** @type {(inputs: Spellcheck_Corrections_List_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lista de correções ortográficas`)
};

/**
* | output |
* | --- |
* | "List of spelling corrections" |
*
* @param {Spellcheck_Corrections_List_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const spellcheck_corrections_list_label = /** @type {((inputs?: Spellcheck_Corrections_List_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spellcheck_Corrections_List_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_spellcheck_corrections_list_label(inputs)
	if (locale === "de") return de_spellcheck_corrections_list_label(inputs)
	if (locale === "it") return it_spellcheck_corrections_list_label(inputs)
	if (locale === "ru") return ru_spellcheck_corrections_list_label(inputs)
	if (locale === "es") return es_spellcheck_corrections_list_label(inputs)
	if (locale === "zh-CN") return zh_cn2_spellcheck_corrections_list_label(inputs)
	if (locale === "ja") return ja_spellcheck_corrections_list_label(inputs)
	if (locale === "hi") return hi_spellcheck_corrections_list_label(inputs)
	if (locale === "pt-PT") return pt_pt2_spellcheck_corrections_list_label(inputs)
	return en_spellcheck_corrections_list_label(inputs)
});